import { Controller } from "@hotwired/stimulus"

// Pre-fills the brand-playground form from a selected preset: sets the model,
// ticks the preset's poses, selects its background, and (when the preset
// carries a custom output format) swaps the format dropdown for a read-only
// "Custom · WxH" badge. Everything else stays editable. The hidden preset_id
// rides along on submit so the controller can apply the preset's framing
// guides, backdrop colour and custom size.
export default class extends Controller {
  static targets = [
    "select", "presetId", "pose", "model", "background",
    "hairstyle", "makeup",
    "sizeRow", "customSizeRow", "customSizeLabel"
  ]

  // On page load — when the form is reopened with a preset already selected
  // (e.g. ?preset_id=N or after a validation failure), reflect that preset's
  // custom format without clobbering the operator's other field values.
  connect() {
    if (!this.hasSelectTarget) return
    if (!this.selectTarget.value) return
    const opt = this.selectTarget.options[this.selectTarget.selectedIndex]
    const customSize = (opt?.dataset.customSize || "").trim()
    if (customSize) this.showCustomSize(customSize)
  }

  apply() {
    const presetId = this.selectTarget.value
    if (this.hasPresetIdTarget) this.presetIdTarget.value = presetId

    if (!presetId) {
      this.clearCustomSize()
      return
    }

    const opt = this.selectTarget.options[this.selectTarget.selectedIndex]

    // Set the model first so the pose-audience filter reveals the right poses
    // before we tick them.
    const modelId = opt.dataset.modelId
    if (modelId && this.hasModelTarget) {
      this.modelTarget.value = modelId
      this.modelTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }

    const poseIds = this.parseIds(opt.dataset.poseIds)
    this.poseTargets.forEach((cb) => { cb.checked = poseIds.includes(cb.value) })

    if (this.hasBackgroundTarget) {
      this.backgroundTarget.value = opt.dataset.background || ""
    }

    if (this.hasHairstyleTarget) {
      this.hairstyleTarget.value = opt.dataset.hairstyleId || ""
    }
    if (this.hasMakeupTarget) {
      this.makeupTarget.value = opt.dataset.makeupId || ""
    }

    const customSize = (opt.dataset.customSize || "").trim()
    if (customSize) {
      this.showCustomSize(customSize)
    } else {
      this.clearCustomSize()
    }
  }

  showCustomSize(size) {
    if (this.hasCustomSizeLabelTarget) this.customSizeLabelTarget.textContent = size
    if (this.hasSizeRowTarget) this.sizeRowTarget.classList.add("d-none")
    if (this.hasCustomSizeRowTarget) this.customSizeRowTarget.classList.remove("d-none")
  }

  clearCustomSize() {
    if (this.hasCustomSizeLabelTarget) this.customSizeLabelTarget.textContent = ""
    if (this.hasSizeRowTarget) this.sizeRowTarget.classList.remove("d-none")
    if (this.hasCustomSizeRowTarget) this.customSizeRowTarget.classList.add("d-none")
  }

  parseIds(raw) {
    try {
      return JSON.parse(raw || "[]").map(String)
    } catch (e) {
      return []
    }
  }
}
